/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Term = {
  type: 'Enum',
} as const;
